import React from 'react';
import { Box } from '@mui/material';
import { ViewColumnOutlined } from '@mui/icons-material';
import { darken } from '@mui/material/styles';
import { PAGE_ACCENTS, PageAccentName } from '../../theme/pageAccents';

interface NotebookColumnTabProps {
  label: string;
  accent: PageAccentName;
  open: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

/** A side index tab attached to a desktop table, like a notebook divider. */
const NotebookColumnTab: React.FC<NotebookColumnTabProps> = ({ label, accent, open, onClick }) => (
  <Box
    component="button"
    type="button"
    aria-label={label}
    aria-haspopup="menu"
    aria-expanded={open}
    title={label}
    onClick={onClick}
    sx={theme => {
      const accentColor = PAGE_ACCENTS[accent][theme.palette.mode];
      return {
        display: { xs: 'none', md: 'flex' },
        position: 'absolute',
        top: -16,
        right: -40,
        zIndex: 2,
        width: 40,
        height: 112,
        p: '10px 6px',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 0.75,
        border: '1px solid',
        borderLeft: 0,
        borderColor: accentColor,
        borderRadius: '0 10px 10px 0',
        bgcolor: open ? darken(accentColor, 0.06) : accentColor,
        color: theme.palette.getContrastText(accentColor),
        boxShadow: '4px 5px 12px rgba(32, 55, 44, .12)',
        fontFamily: 'inherit',
        fontSize: 11,
        fontWeight: 750,
        lineHeight: 1,
        letterSpacing: '0.08em',
        cursor: 'pointer',
        transition: 'background-color 150ms ease',
        '&:hover': { bgcolor: darken(accentColor, 0.08) },
        '&:focus-visible': { outline: `2px solid ${accentColor}`, outlineOffset: 2 },
      };
    }}
  >
    <ViewColumnOutlined sx={{ fontSize: 18, flexShrink: 0 }} />
    <Box component="span" sx={{ writingMode: 'vertical-rl' }}>{label}</Box>
  </Box>
);

export default NotebookColumnTab;
